import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "./index.scss";
import { FaUsers, FaRocket, FaChartBar, FaBuilding, FaDatabase, FaFileAlt } from "react-icons/fa";
import { MOAIcon } from "../../../assets/icons/MOAIcon";
import { TechnologiesIcon } from "../../../assets/icons/TechnologiesIcon";
import { PHPIcon } from "../../../assets/icons/PHPIcon";

import { BigDataIcon } from "../../../assets/icons/BigDataIcon";
import { InfrastructureIcon } from "../../../assets/icons/InfrastructureIcon";
import { useNavigate } from "react-router-dom";



const ServicesSection = ({services}) => {
        const navigate = useNavigate();
  return (
    <div className="services-section-service py-5">
      <div className="container-section-service">
        <Row className="gx-4 gy-4">
          {services.map((service, index) => (
            <Col md={6} key={index}>
              <div className={`service-card ${service.variant} d-flex justify-content-between`}>
 
                <div className="text">
                  <h5>{service.title}</h5>
                  <p>{service.description}</p>
                </div>
                               <div className="icon">{service.icon}</div>
              </div>
            </Col>
          ))}
          
        </Row>
            <Row className="gx-4 gy-4 mt-1"> <Col md={6}>
            <Button className="request-button w-100" onClick={() => {
                  navigate(`/demandez-devis`);
                  window.scrollTo(0, 0);
                }}>Demandez un devis</Button>
          </Col></Row>
      </div>
    </div>
  );
};

export default ServicesSection;
